// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';

import { useTranslator } from '@gandi/translate';
import { Alert, Base, Placeholder } from '@gandi/ui';

import { withRouter } from 'src/helpers/withRouter';

import type { WithRouterProps } from '../../helpers/withRouter';
import { fetchDomainInfos } from '../modules/actions';
import type { DomainInfo } from '../types';

type Props = { ...WithRouterProps<{ fqdn: string }> };
export const MailboxLegacyExpiration: React.ComponentType<{}> = withRouter(
  ({ params: { fqdn } }: Props): React.MixedElement => {
    const dispatch = useDispatch();
    const { __, formatDate } = useTranslator();

    // $FlowFixMe[react-rule-hook]
    const [isFetching, setIsFetching] = React.useState(false);
    // $FlowFixMe[react-rule-hook]
    const [domainInfos, setDomainInfos] = React.useState<void | DomainInfo>();

    // $FlowFixMe[react-rule-hook]
    React.useEffect(() => {
      setIsFetching(true);
      dispatch(fetchDomainInfos(fqdn))
        .then(response => setDomainInfos(response.data))
        .catch(() => {
          // Nothing
        })
        .finally(() => {
          setIsFetching(false);
        });
    }, [dispatch, fqdn]);

    return (
      <Alert
        intent="info"
        title={__('Information about this mailbox offer')}
        message={
          <>
            {isFetching ? (
              <Placeholder display="inline-block" chars={60} />
            ) : (
              <Base tagName="p">
                {__(
                  'The expiration date of the legacy mailboxes is linked to your domain expiration date.',
                )}
              </Base>
            )}
            {domainInfos && (
              <Base tagName="p">
                {__('Your domain %(fqdn)s will expire on %(date)s.', {
                  fqdn,
                  date: formatDate(domainInfos.dates.date_registry_end, 'LL'),
                })}
              </Base>
            )}
          </>
        }
      />
    );
  },
);
